import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { studyTools } from '../../data/content';
import { getIcon } from '../../utils/icons';
export function StudyTools() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-336" data-mp="28nsaf71ft338">
      <div className="mx-auto max-w-5xl" data-id="element-337" data-mp="2dgv5jjlv4klj">
        <SectionHeading eyebrow="Plus" title={<span id="tools-title" data-id="element-339" data-mp="2ieeh2br6ej9s">You’ll receive practical professional study tools</span>} subtitle="The Blueprint™ includes complementary educational resources designed to make your reference collection even more useful." data-id="element-338" data-mp="2dhwixuqcpj6f" />

        <ul className="mt-12 grid overflow-hidden rounded-3xl bg-paper ring-1 ring-navy-900/5 md:grid-cols-2" data-id="element-340" data-mp="2re1njbyrif9p">
          {studyTools.map((t, i) => {
          const Icon = getIcon(t.icon);
          return <li key={t.title} className={`flex gap-4 p-5 sm:p-7 ${i > 0 ? 'border-t border-navy-900/10' : ''} ${i === 1 ? 'md:border-t-0' : ''} ${i % 2 === 1 ? 'md:border-l md:border-navy-900/10' : ''}`} data-id="element-341" data-mp="120ob0zghxkxi" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy-950 text-brand" data-id="element-342" data-mp="ig61h2sht7ol">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-343" data-mp="efdp40obqmo3" />
                </span>
                <div data-id="element-344" data-mp="1b4lfblzw1jyc">
                  <h3 className="text-lg font-extrabold leading-snug text-ink" data-id="element-345" data-mp="1b3sd8ybvjimj">{t.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-346" data-mp="165iiupxz4m1z">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base font-semibold text-ink" data-id="element-347" data-mp="x52frhl57gxn">
          Everything is organized to help you navigate your educational resources without jumping between disconnected
          documents.
        </p>

        <SectionCTA label="I want access to the complete system" data-id="element-348" data-mp="3hui2o1h8qli0" />
      </div>
    </section>;
}